import WarningIcon from "assets/svg/small-warning.svg";

import styles from "./styles.module.css";

const ListingDeletedInfoCard = () => {
  return (
    <div className={styles.wrapper}>
      <WarningIcon />
      <p className={styles.info}>
        Aradığınız ilan yayından kaldırılmış. Dilerseniz aynı bölgedeki diğer ilanları inceleyebilirsiniz.
      </p>
    </div>
  );
};

export default ListingDeletedInfoCard;
